import React, { useEffect, useState } from 'react';
import { GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import { useDispatch } from 'react-redux';
import {
  fetchApplicationConfiguration,
  updateApplicationConfiguration,
} from '../../../store/actions/newAdmissionAction';

import { Col, Form, Row } from 'antd';
import { FormTextInput } from '../../../shared/components/crmFormElement/FormInput';
import CustomTag from '../../../shared/components/customTag/customTag';
import { centeredNotification } from '../../../utils/utility';

const InboundProviderIdsConfigurator: React.FC = (): any => {
  const [inboundProviderIds, setInboundProviderIds] = useState<string[]>([]);
  const dispatch = useDispatch();
  const [providerIdsForm] = Form.useForm();

  useEffect((): any => {
    const fetchIdsPayload = {
      keyName: 'InboundProviderIds',
    };
    dispatch(fetchApplicationConfiguration(fetchIdsPayload, OnGetInboundProviderIdsSuccess, OnGetInboundProviderIdsError));
  }, []);

  const OnGetInboundProviderIdsSuccess = (response: any): any => {
    setInboundProviderIds(response.split(','));
  };

  const OnGetInboundProviderIdsError = (errMsg: any): any => {
    centeredNotification(errMsg);
  };

  const onSaveProviderIds = async (): Promise<void> => {
    const providerIdsFormObj = await providerIdsForm?.validateFields();
    const newProvierIds: string = (providerIdsFormObj?.['providerIds'] || '')?.replace(/\s+/g, '');
    const filteredProviderIds = newProvierIds?.split(',')?.filter((ele: any): any => !inboundProviderIds?.includes(ele));
    if (filteredProviderIds?.length) {
      const updateIdsPayload = {
        keyName: 'InboundProviderIds',
        keyValue: inboundProviderIds?.join(',')?.concat(',' + filteredProviderIds?.join(',')),
      };
      dispatch(updateApplicationConfiguration(updateIdsPayload, (res: any): any => {
        setInboundProviderIds(inboundProviderIds.concat(filteredProviderIds));
        centeredNotification(res, 'success');
        providerIdsForm?.resetFields();
      }, OnGetInboundProviderIdsError));
    } else {
      centeredNotification('Provider Id already exists');
    }
  };

  const onRemove = (removeId: any): any => {
    const filteredProviderIds = inboundProviderIds?.filter((ele: any): any => ele !== removeId);
    if (filteredProviderIds?.length) {
      const updateIdsPayload = {
        keyName: 'InboundProviderIds',
        keyValue: filteredProviderIds?.join(','),
      };
      dispatch(updateApplicationConfiguration(updateIdsPayload, (res: any): any => {
        setInboundProviderIds(filteredProviderIds);
        centeredNotification(res, 'success');
        providerIdsForm?.resetFields();
      }, OnGetInboundProviderIdsError));
    }
  };

  return (
    <React.Fragment>
      <div>
        <Form form={providerIdsForm} className="flex-element flex-col gap-5">
          <Row gutter={GUTTOR_SPACE} className={'PayerEmailConfiguration'}>
            <Col className="m-10 font-12 font-weight-text">
              <div><b>Configure Inbound Provider IDs</b></div>
            </Col>
          </Row>
          <p className="p-14 font-12">Enter multiple supreme Ids separated by "," and click Save.</p>
          <Row gutter={GUTTOR_SPACE} className="flex flex-row align-baseline">
            <Col md={10}>
              <FormTextInput detail={{
                key: 'providerIds',
                placeholder: 'Enter provider Ids',
                hideLabel: true,
              }} />
            </Col>
            <Col md={1}>
              <a onClick={(): any => onSaveProviderIds()} className="mouse-pointer bold">SAVE</a>
            </Col>
          </Row>
          <Row>
            {
              inboundProviderIds?.map((id: any, index: any): any =>
                <CustomTag text={id} key={index} removable={true} onRemove={(): any => onRemove(id)} />,
              )
            }
          </Row>
        </Form>
      </div>
    </React.Fragment>
  );
};

export default InboundProviderIdsConfigurator;
